module.exports = __webpack_public_path__ + "public/img/sbjk.5bed081e.png";